import * as Yup from "yup";

const RangeSchema = Yup.object({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  From: Yup.string().required("This is a required field"),
  To: Yup.string().required("This is a required field"),
  Length: Yup.number().required("This is a required field").min(13).max(20),
  Account: Yup.array(
    Yup.string().oneOf(["Cheque", "Savings", "Credit", "Default"])
  ),
});

const PromptSchema = Yup.object({
  Label: Yup.string().required("This is a required field"),
  Hint: Yup.string(),
  Type: Yup.string().oneOf(["AMOUNT", "NUMBER", "TEXT", "OPTIONS"]),
  MinCharacters: Yup.number(),
  MaxCharacters: Yup.number(),
  Tag: Yup.string(),
  Language: Yup.string(),
});

const BinSchema = Yup.object({
  Range: Yup.array(RangeSchema),
  Prompt: Yup.array(PromptSchema),
});

const schema = Yup.object({
  id: Yup.string(),
  attributes: Yup.object({
    Name: Yup.string().required("This is a required field"),
    Bin: Yup.array(BinSchema),
  }),
});
export default schema;
